module.exports = __webpack_public_path__ + "static/pattern-design-principles-f35a58a1704137e7f80ca609feaa5fd2.png";